module.exports = __webpack_public_path__ + "static/media/ring1.e56952c8.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/branding/default/audio/ring1.mp3
// module id = 590
// module chunks = 0